import { Monitor } from "lucide-react";

/**
 * Subtle in-editor notice. Shows only below the `lg` breakpoint. Does not block
 * the module — users can still browse projects, preview, publish etc.
 */
export default function DesktopRecommendedNotice({ children }) {
  return (
    <div
      className="lg:hidden mx-3 mt-3 mb-2 kr-card p-3 flex items-start gap-3 border border-white/10"
      data-testid="desktop-recommended-notice"
      role="note"
    >
      <div className="w-9 h-9 rounded-md border border-white/10 flex items-center justify-center shrink-0" style={{ background: "rgba(138,82,255,0.10)" }}>
        <Monitor className="h-4 w-4" style={{ color: "rgb(var(--ac-purple))" }} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold">Best experienced on desktop</div>
        <div className="text-xs text-white/50 mt-0.5">
          {children || "Advanced editing here is optimized for a larger screen. You can still preview, publish and manage projects on mobile."}
        </div>
      </div>
    </div>
  );
}
